import SetMaps from './modules/setMaps.js';

(function($){
    $(document).ready(function($){
        new SetMaps();
        $('.lei-print-btn').on('click', function(e){
            e.preventDefault();
            window.print();
        });
    });

})( jQuery );